import React from 'react';
import '../styles/SkipButton.css';

export const SkipButton = ({ idName }) => {
  return (
    <>
      <a href={idName} tabIndex={1} className='skip-link'>
        Menuju konten
      </a>
    </>
  );
};
